import React from "react";
import TemplateRenderer from "./templates/TemplateRenderer";

export default function ResumePreview({ draft }) {
  return <TemplateRenderer templateId={draft.template} colorId={draft.template_color} draft={draft} />;
}
